import React, { useCallback, useState } from 'react';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { Lead } from 'models/Lead';
import WidthrawLeadModal from '../components/WidthrawLeadModal';

export default function useWithdrawLead(
  onWithdraw: (lead: Lead, revokeDataRoomAccess: boolean) => Promise<boolean>,
) {
  const [withdrawnLead, setWithdrawnLead] = useState<Lead>();
  const [withdrawModal, withdrawModalRef] = useCallbackRef<ModalRef>();

  const openWithdrawModal = useCallback(
    (lead: Lead) => {
      setWithdrawnLead(lead);
      withdrawModal?.open();
    },
    [withdrawModal],
  );

  const withdrawLeadModal = (
    <WidthrawLeadModal
      ref={withdrawModalRef}
      lead={withdrawnLead}
      onWithdraw={(revokeDataRoomAccess) =>
        onWithdraw(withdrawnLead, revokeDataRoomAccess)
      }
    />
  );

  return { openWithdrawModal, withdrawLeadModal };
}
